export default __webpack_public_path__ + "static/media/delete.74dbf45c.svg";